import {
	createCookie,
	getQueryParams,
	readCookie
} from "~/public/utilities/utilities";
import toggleDesktopMegaMenu from "./toggleDesktopMegaMenu";

/**
 * globalHead.js Vanilla JavaScript that should be loaded in the HEAD section.
 *
 * Please keep this file light. Most logic should be in global.js which loads
 * before the closing BODY tag. jQuery is NOT available when this file runs.
 */

/**
 * sonicGlobal namespace.
 * @namespace
 */
window.sonicGlobal = window.sonicGlobal || {};

window.createCookie = createCookie;
window.dataLayer = window.dataLayer || [];
window.getQueryParams = getQueryParams;
window.readCookie = readCookie;
window.toggleDesktopMegaMenu = toggleDesktopMegaMenu;
// Aliases
window.getCookie = window.readCookie;
window.QueryString = window.getQueryParams;
window.setCookie = window.createCookie;
window.setupCookie = window.createCookie;

/**
 * Delete the cookie.
 * @param {string} name
 */
window.eraseCookie = function(name) {
    createCookie(name, '', -1);
};

{
	let sonic_afg_data = JSON.parse(decodeURIComponent(readCookie('sonic_afg_data'))) || {};
	/**
	 * @property {string} Customer vehicle year from cookies.
	 */
	sonicGlobal.year = sonic_afg_data.hasOwnProperty('year') ? sonic_afg_data['year'] : '';
	/**
	 * @property {string} Customer vehicle make from cookies.
	 */
	sonicGlobal.make = String(sonic_afg_data.hasOwnProperty('make') ? sonic_afg_data['make'] : '');
	/**
	 * @property {string} Customer vehicle model from cookies.
	 */
	sonicGlobal.model = String(sonic_afg_data.hasOwnProperty('model') ? sonic_afg_data['model'] : '');
	/**
	 * @property {string} URL encoded customer vehicle make from cookies.
	 */
	sonicGlobal.urlMake = sonicGlobal.make.replace(/\+/g, '-').replace(/%26/g, '&').replace(/\s+/g, '-').toLowerCase();
	/**
	 * @property {string} URL encoded customer vehicle model from cookies.
	 */
	sonicGlobal.urlModel = sonicGlobal.model.replace(/\+/g, '-').replace(/%26/g, '&').replace(/\s+/g, '-').toLowerCase();
	/**
	 * @property {string} Display version of the customer vehicle make from cookies.
	 */
	sonicGlobal.displayMake = sonicGlobal.make.replace(/\+/g, ' ');
	/**
	 * @property {string} Display version of the customer vehicle model from cookies.
	 */
	sonicGlobal.displayModel = sonicGlobal.model.replace(/\+/g, ' ').replace(/%26/g, 'and');
	/**
	 * Turns on the overlay and removes overflow on the page.
	 * @param {Boolean} dark TRUE to increase the opacity of the overlay.
	 * @returns {undefined}
	 */
	sonicGlobal.overlayActivate = function(dark) {
		document.getElementById('black-overlay').classList.add('active');
		if (dark) {
			document.body.classList.add('body-opa');
		}
	};
	/**
	 * Turns off the overlay and restores overflow on the page.
	 * @returns {undefined}
	 */
	sonicGlobal.overlayDeactivate = function() {
		document.getElementById('black-overlay').classList.remove('active');
		document.body.classList.remove('body-opa');
	};
	/**
	 * Uppercase the first character of each word and lowercase the rest.
	 * @param {string} str
	 * @returns {string}
	 */
	sonicGlobal.toTitleCase = function(str) {
		return str.replace(/\w\S*/g, function(str) {
			return str.charAt(0).toUpperCase() + str.substr(1).toLowerCase();
		});
	};
}
